import * as R from 'ramda';
import {Map, Set, isImmutable } from 'immutable';
import { is, reduceWhile } from 'ramda';
import { get } from '@synergycms_core/utils';
import storage from "synergycms_core/src/utils/storage";



export const getTranslation = (langs, entity, fields, defaultText) => {
  langs = !R.contains('en', langs) ? langs.push('en') : langs;
  if (isImmutable(entity)) {
    if (entity.get('translations')) {
      const translation = entity.get('translations');
      return (
        R.reduceWhile(
          value => !value,
          (acc, lang) => {
            return R.reduceWhile(
              value => !value,
              (acc, field) => {
                return translation.getIn([lang, field]);
              },
              null,
              fields
            );
          },
          null,
          langs
        ) || defaultText
      );
    }
  } else if (is(Object, entity)) {
    if (entity.translations) {
      const translations = entity.translations;
      return (
        R.reduceWhile(
          value => !value,
          (acc, lang) => {
            return R.reduceWhile(
              value => !value,
              (acc, field) => {
                return get([lang, field], translations);
              },
              null,
              fields
            );
          },
          null,
          langs
        ) || defaultText
      );
    }
  } else {
    return defaultText;
  }
};

export const updateIn = R.curry((path, val, obj) =>
  R.compose(
    R.set(R.__, val, obj),
    R.apply(R.compose),
    R.map(R.cond([[R.is(Number), R.lensIndex], [R.T, R.lensProp]]))
  )(path)
);

/**
 *
 * @param number
 * @param decimals
 * @returns {number}
 */
export const round = (number, decimals = 2) => Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

/**
 *
 * @param input
 * @returns {string}
 */
export const lowerFirst = input => input.charAt(0).toLowerCase() + input.substring(1, input.length);

/**
 *
 * @param deg
 * @returns {number}
 */
const deg2rad = function (deg) {
  return deg * (Math.PI / 180);
};

/**
 *
 * @param number
 * @param decPlaces
 * @param thouSeparator
 * @param decSeparator
 * @returns {string}
 */
export const formatNumber = (number, decPlaces, thouSeparator, decSeparator) => {
  decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
  thouSeparator = thouSeparator === undefined ? ',' : thouSeparator;
  decSeparator = decSeparator === undefined ? '.' : decSeparator;
  const sign = number < 0 ? '-' : '';
  const i =
    parseInt((number = Number(Math.round(Math.abs(+number || 0) + 'e' + decPlaces) + 'e-' + decPlaces)), 10) + '';
  const j = i.length > 3 ? i.length % 3 : 0;
  return (
    sign +
    (j ? i.substr(0, j) + thouSeparator : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thouSeparator) +
    (decPlaces
      ? decSeparator +
      Number(Math.round(Math.abs(number - i) + 'e' + decPlaces) + 'e-' + decPlaces)
        .toFixed(decPlaces)
        .slice(2)
      : '')
  );
};

/**
 *
 * @param objectMap
 * @returns {function(...[*]): *}
 */
export const immutablePick = objectMap => (...keys) => objectMap.filter(keyIn(...keys));

/**
 *
 * @param keys
 * @returns {function(*, *=): boolean}
 */
export const keyIn = (...keys) => (v, k) => Set(keys).has(k);

/**
 *
 */
export const splice = (input, start, delCount, newSubStr) => {
  return input.slice(0, start) + newSubStr + input.slice(start + Math.abs(delCount));
};


/**
 * Funcio per recuperar les diferencies entre 2 objectes, perfecte per controlar els canvis a les props i refresh de components
 * @param {*}
 * @param {*}
 * @returns {*}
 */

const isObject = R.compose(
  R.equals('Object'),
  R.type
);
const allAreObjects = R.compose(
  R.all(isObject),
  R.values
);
const hasLeft = R.has('left');
const hasRight = R.has('right');
const hasBoth = R.both(hasLeft, hasRight);
const isEqual = R.both(
  hasBoth,
  R.compose(
    R.apply(R.equals),
    R.values
  )
);

const markAdded = R.compose(
  R.append(undefined),
  R.values
);
const markRemoved = R.compose(
  R.prepend(undefined),
  R.values
);
const isAddition = R.both(hasLeft, R.complement(hasRight));
const isRemoval = R.both(R.complement(hasLeft), hasRight);

export const objectDiff = R.curry(_diff);
function _diff(l, r) {
  return R.compose(
    R.map(
      R.cond([
        [isAddition, markAdded],
        [isRemoval, markRemoved],
        [
          hasBoth,
          R.ifElse(
            allAreObjects,
            R.compose(
              R.apply(objectDiff),
              R.values
            ),
            R.values
          )
        ]
      ])
    ),
    R.reject(isEqual),
    R.useWith(R.mergeWith(R.merge), [R.map(R.objOf('left')), R.map(R.objOf('right'))])
  )(l, r);
}

export const dispatchEvent = (name, detail) => {
  const event = new CustomEvent(name, { detail });
  document.dispatchEvent(event);
};

export const reduceWhileResolved = (store, storeKey) => {
  const hotelsIds = store.getIn(['customer', 'current_hotels']);
  const itemsResolveds = reduceWhile(
    (itemsResolveds, hotelId) => {
      if (storeKey === 'hotels') {
        return is(Boolean, store.getIn([storeKey, hotelId, 'success']));
      } else {
        const queryParams = store.getIn(['hotels', hotelId, 'params', 'string_query_params']);
        return store.getIn([storeKey, hotelId, queryParams, 'raw_response']);
      }
    },
    (itemsResolveds, hotelId) => itemsResolveds.set(hotelId, store.getIn([storeKey, hotelId])),
    new Map(),
    hotelsIds
  );
  return hotelsIds.size > 0 && hotelsIds.size === itemsResolveds.size ? itemsResolveds : undefined;
};


export const correctSelection =  () => {

    let correctSelection = true;
    let selectionCount =0;
    //let reservationSelecton = reservationRequest;
    let selection = storage.get('gift_voucher_selection');
    selection.forEach(selected => {
        var foundItem = window.gift_voucher_list.find(item => item.id === selected.id.toString());
        if(!foundItem){
            correctSelection = false;
        }
        else {
            selectionCount += selected.count;
        }
    });

    let hasSelection = selection.length >= 1 && selectionCount > 0 && correctSelection;

    return hasSelection ? hasSelection : undefined;
};


export const getUrlConfirmation =  () => {

    let url = window.engine_sygy_data.url.confirmation;
    let selection = storage.get('gift_voucher_selection');
    url = url + '?';
    let params = [];
    selection.forEach(selected => {
        if(selected.count > 0){
            params.push('modulo[giftVoucher][]=' + selected.id + ':' +selected.count);
        }
    });
    let urlParams = params.join('&');
    url = url + urlParams;
    return url;
};